import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    username: '',
    avatarimg: '',
    userid:''
  },
  mutations: {
    getuserInfo(state, step) {
      state.username = step.username
      state.avatarimg = step.image
      state.userid = step.id
    },
    emptyUserInfo(state) {
      state.username = ''
      state.avatarimg = ''
    },
  },
  actions: {
    userinfo(context, step) {
      context.commit('getuserInfo', step)
    },
    isclickLogin(){

    },
    // isclickLogin
    userinfoEmpty(context) {
      context.commit('emptyUserInfo')
    },
  },
  modules: {}
})